<template>
  <!-- ユーザ管理 -->
  <div id="AppUserManagement">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <label class="searchTitle label">ユーザ管理</label>
      <b-tabs type="is-boxed">
        <b-tab-item label="ログインユーザ情報" icon="account-circle">
          <editUser />
        </b-tab-item>
        <b-tab-item v-if="roleId!=2 && roleId!=7" label="ユーザ検索" icon="account-search">
          <searchUser />
        </b-tab-item>
        <b-tab-item v-if="roleId===1" label="参照可能営業所設定" icon="home-variant">
          <referenceOffice />
        </b-tab-item>
        <b-tab-item v-if="roleId===1" label="ユーザ追加" icon="account-plus">
          <addUser />
        </b-tab-item>
        <b-tab-item v-if="roleId===1" label="ユーザ一括追加" icon="account-multiple-plus">
          <addUserList />
        </b-tab-item>
      </b-tabs>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import SearchUserTemplate from "./AppUserManagementSearchUser";
import EditUserTemplate from "./AppUserManagementEditUserTab";
import ReferenceOfficeTemplate from "./AppUserManagementReferenceOffice";
import AddUserTemplate from "./AppUserManagementAddUserTab";
import AddUserListTemplate from "./AppUserManagementAddUserList";

export default {
  name: "AppUserManagement",
  methods: {},
  data() {
    var roleId = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
    return {
      roleId: roleId
    };
  },
  filters: {},
  components: {
    searchUser: SearchUserTemplate,
    editUser: EditUserTemplate,
    referenceOffice: ReferenceOfficeTemplate,
    addUser: AddUserTemplate,
    addUserList: AddUserListTemplate
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppUserManagement.vue